import axios from 'axios';
import {
  LoginDto,
  LoginResponseDto,
  SignupUserDto,
  UserNoPassword,
} from 'types';
import { convertUser } from './dtoConverters';

// Signup functionality under the Nest API is unused and therefore untested as of 9/10/21
export async function signup(user: SignupUserDto): Promise<UserNoPassword> {
  const url = `/api/auth/signup`;

  try {
    const { data } = await axios.post(url, convertUser(user));
    return data as UserNoPassword;
  } catch (err) {
    throw err;
  }
}

export async function login(user: LoginDto): Promise<LoginResponseDto> {
  const url = `/api/auth/login`;

  try {
    const { data: loginResponse } = await axios.post(url, user);
    return loginResponse as LoginResponseDto;
  } catch (err) {
    throw err;
  }
}

export async function loginWithLdap(user: any): Promise<LoginResponseDto> {
  const url = `/api/auth/ldap-login`;

  try {
    const { data: loginResponse } = await axios.post(url, user);
    return loginResponse as LoginResponseDto;
  } catch (err) {
    throw err;
  }
}
